<template>
  <EmailList :type="2" />
</template>
<script setup>
import EmailList from './components/EmailList/EmailList.vue';
</script>
<style lang="less" scoped>
</style>